module.exports = __webpack_public_path__ + "static/media/RefreshIcon.a94e0d6b.svg";